import { IDateRange } from "@tether-web-portal/types/common";
import { TimestampRange } from "@tether-web-portal/types/TimestampRange";

export const normalizeMetricsIntervalDateRange = (dateRange: IDateRange): IDateRange => ({
  startDate: dateRange.startDate?.isValid() ? dateRange.startDate : null,
  endDate: dateRange.endDate?.isValid() ? dateRange.endDate : null,
});

export const getMetricsIntervalPickerDates = (
  pendingDateRange: IDateRange,
  metricsTimeStamps: TimestampRange,
) => ({
  startDate: pendingDateRange.startDate ?? metricsTimeStamps.fromTimestamp,
  endDate: pendingDateRange.endDate ?? pendingDateRange.startDate ?? metricsTimeStamps.toTimestamp,
});

export const getMetricsIntervalButtonDates = (
  pendingDateRange: IDateRange,
  metricsTimeStamps: TimestampRange,
) => ({
  startDate:
    pendingDateRange.startDate && !pendingDateRange.endDate
      ? metricsTimeStamps.fromTimestamp
      : (pendingDateRange.startDate ?? metricsTimeStamps.fromTimestamp),
  endDate:
    pendingDateRange.startDate && !pendingDateRange.endDate
      ? metricsTimeStamps.toTimestamp
      : (pendingDateRange.endDate ?? metricsTimeStamps.toTimestamp),
});
